/* Header.js */
import React from "react";
import styles from "./Header.module.css";
import footyLogo from "./images/45deg-red-football-144.png";

const Header = () => (
  <header className={styles.header}>
    <img className={styles.headerImg} src={footyLogo} alt="Footy Logo" />

    <div className={styles.headerContent}>
      <h1 className={styles.h1}>footy rounds</h1>
    </div>
  </header>
);

export default Header;
